import React, { PureComponent } from 'react';
import { Card, CardBody, Row, Col, Button, ButtonToolbar } from 'reactstrap';
import SearchIcon from 'mdi-react/SearchIcon';
import Select from 'react-select';
import { withTranslation } from 'react-i18next';
import { checkKey } from "../../Services/SecurityService";
import { check, findAllRequerimentoWithCidadesByEstadoCidade } from "../../Services/RequerimentoService";
import { findAllEstado } from "../../Services/EstadoService";
import { findCidadeByEstado } from "../../Services/CidadeService";
import { findAllSubstanciaByEnabled } from "../../Services/SubstanciaService";
import { findAllRequerimentoFaseByEnabled } from "../../Services/RequerimentoFaseService";
import PropTypes from 'prop-types';
import MatTable from './MaterialTable/MatTable';
import CrudEdit from './edit';
import { environment } from '../../environment';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { createBrowserHistory } from 'history'

const hist = createBrowserHistory()

let notificationTC = null;

class CrudList extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };
  
  constructor(props) {
    super(props);
    this.setSelected = this.setSelected.bind(this)

    this.state = {

      fases: [],
      selectedFase: '',
      selectOptionsF: [],

      substancias: [],
      selectedSub: '',
      selectOptionsSub: [],

      hasAccess: false,
      
      selected: {},

      estados: [],
      statesList: [],
      selectedStates: [{value:0, label: this.props.t('forms.loading')+"..."}],
      selectedEstados: [],

      cidades: [],
      citiesList: [],
      selectedCities: [],
      selectedCidades: [],

      filter: {
				processo: '',
				name: '',
				substancia: '',
				fase: ''
      },
      processo: '',
      
      data: []
    };
    check();
  }

  loadRequerimento(selected){
    if(this.state.selectedEstados.length > 0){
      let request = {
        cidade: (this.state.selectedCidades.length > 0 ? this.state.selectedCidades[0] : null),
        estado: this.state.selectedEstados[0],
        proccess: (this.state.processo !== '' ? this.state.processo : (this.state.filter.processo !== '' ? this.state.filter.processo : null)),
        name: (this.state.filter.name !== '' ? this.state.filter.name : null),
        substancia: (this.state.filter.substancia !== '' ? this.state.filter.substancia : null),
        requerimentoFase: (this.state.filter.fase !== '' ? this.state.filter.fase : null)
      }

      document.getElementById("processosEncontradosID").innerHTML = this.props.t('forms.searhing')+"...";

      findAllRequerimentoWithCidadesByEstadoCidade(request)
      .then(response => {
        if(response === undefined){
          response = [];
        }
        
        if(response.error === undefined && response.erros.length === 0){
          if(response.requerimentoList !== null){
            for(let i = 0; i < response.requerimentoList.length; i++){
              response.requerimentoList[i].cidadeList = response.requerimentoList[i].cidadeDivisa.substring(0,response.requerimentoList[i].cidadeDivisa.lastIndexOf(";")).split(";");
            }
            document.getElementById("processosEncontradosID").innerHTML = this.props.t('forms.processosEncontrados') + ": " + response.requerimentoList.length;
            this.setState({ data: response.requerimentoList, processo: '', selected });
          }else{
            document.getElementById("processosEncontradosID").innerHTML = this.props.t('forms.processosEncontrados') + ": 0"
            this.setState({ data: [], processo: '', selected });
          }
        } else {
          document.getElementById("processosEncontradosID").innerHTML = this.props.t('forms.processosEncontradosError');
          if(response.erros !== undefined && response.erros !== undefined && response.erros.length > 0){
            for(let i = 0; i < response.erros.length; i++){
              if(response.erros[i] !== "sqlException"){
                this.show('danger', this.props.t('erros.'+response.erros[i]));
              }else{
                i++;
                console.log(response.erros[i]);
              }
            }
          } 
        }
      });
    }else{
      this.show('danger', this.props.t('forms.erro_0057'));
    }
  }

  loadCidades(estado, cidade, loadRequerimento = false){
    findCidadeByEstado(estado.id)
    .then(response => {
      if(response === undefined){
        response = [];
      }
      let options = [];
      let cidades = [];
      let selectedCities = [];
      if(response !== undefined && response.error === undefined){
        cidades = response;
        if(cidades !== undefined && cidades !== null && cidades.length > 0){
          for(let i = 0; i < cidades.length; i++){
            options.push({value:cidades[i].id, label: cidades[i].name});
          }
        }
      } else {
        if(response.errors === undefined){
          response = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          response = [];
          this.show('danger', response.errors[0].defaultMessage);
        }
      }
      this.setState({ 
        cidades,
        citiesList: options,
        selectedCities
      }, () => {
        if(cidade !== null){
          this.setCidade(cidade, loadRequerimento);
        }
      });
    });
  }

  setCidade(cidade, loadRequerimento = false){
    let selectedCities = [];
    let selectedCidades = [];
    if(cidade !== null){
      for(let i = 0; i < this.state.cidades.length; i++){
        if(this.state.cidades[i].id === cidade.id){
          console.log(cidade);
          selectedCities.push({value: this.state.cidades[i].id, label: this.state.cidades[i].name});
          selectedCidades.push(this.state.cidades[i]);
          break;
        }
      }
    }
    this.setState({ selectedCities, selectedCidades }, () => {
      if(selectedCidades.length > 0 && loadRequerimento){
        this.loadRequerimento({});
      }
    });
  }

  loadEstado(loadRequerimento = false){
    findAllEstado()
    .then(response => {
      if(response === undefined){
        response = [];
      }
      let options = [];
      let estados = [];
      if(response !== undefined && response.error === undefined){
        estados = response;
        if(estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0){
          for(let i = 0; i < estados.length; i++){
            options.push({value:estados[i].id, label: estados[i].name});
          }
          this.setState({ 
            estados,
            statesList: options, 
            hasAccess: true
          }, () => {
            let user = environment.getUser();
            let stateFilter = environment.getStateFilter();
            let cityFilter = environment.getCityFilter();
            let state = null;
            let city = null;

            if(user !== null && user.cidade !== undefined && user.cidade !== null && user.cidade.id !== null){
              state = user.cidade.estado;
              city = user.cidade;
            }
            
            if(stateFilter !== null){
              if(state === null){
                state = {id: 0};
              }
              state.id = parseInt(stateFilter);
            }
            if(cityFilter !== null){
              if(city === null){
                city = {id: 0};
              }
              city.id = parseInt(cityFilter);
            }

            if(state !== undefined && state !== null && state.id !== null && state.id > 0){
              this.setEstado(state, city, loadRequerimento);
            }
          });
        }
      } else {
        if(response.errors === undefined){
          response = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          response = [];
          this.show('danger', response.errors[0].defaultMessage);
        }
      }
    });
  }

  setEstado(estado, cidade, loadRequerimento = false){
    let selectedStates = [];
    let selectedEstados = [];
    let citiesList = [];
    let selectedCities = [];
    let selectedCidades = [];

    if(estado !== null){
      for(let e = 0; e < this.state.estados.length; e++){
        if(this.state.estados[e].id === estado.id){
          selectedStates.push({value: this.state.estados[e].id, label: this.state.estados[e].name});
          selectedEstados.push(this.state.estados[e]);
          selectedCities.push({value:0, label: this.props.t('forms.loading')+"..."});
          break;
        }
      }
    }
    this.setState({ selectedStates, selectedEstados, citiesList, selectedCities, selectedCidades }, () => {
      if(selectedEstados.length > 0){
        this.loadCidades(estado, cidade, loadRequerimento);
      }
    });
  }

  loadFase(){
    if(this.state.fases.length === 0){
      findAllRequerimentoFaseByEnabled(0)
      .then(data => {
        if(data === undefined){
          data = [];
        }
        if(data !== undefined && data.error === undefined){
          let options = [];
          for(let i = 0; i < data.length; i++){
            options.push({value:data[i].id, label: data[i].name});
          }
          this.setState({ 
            selectOptionsF: options, 
            fases: data 
          });
        } else {
          if(data.errors === undefined){
            data = [];
            this.show('danger', this.props.t('forms.errorListData'));
          } else {
            data = [];
            this.show('danger', data.errors[0].defaultMessage);
          }
        }
      });
    }
  }

  loadSubstancia(){
    if(this.state.substancias.length === 0){
      findAllSubstanciaByEnabled(0)
      .then(data => {
        if(data === undefined){
          data = [];
        }
        if(data !== undefined && data.error === undefined){
          let options = [];
          for(let i = 0; i < data.length; i++){
            options.push({value:data[i].id, label: data[i].name});
          }
          this.setState({ 
            selectOptionsSub: options, 
            substancias: data 
          });
        } else {
          if(data.errors === undefined){
            data = [];
            this.show('danger', this.props.t('forms.errorListData'));
          } else {
            data = [];
            this.show('danger', data.errors[0].defaultMessage);
          }
        }
      });
    }
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    if(checkKey("MENU_REQUIREMENT_PROCCESS")){

      // console.log(this.props);
      if(this.props !== undefined && this.props.search !== undefined && this.props.search.match !== undefined && this.props.search.match.params !== undefined){
        if(this.props.search.match.params.proccess !== undefined){
          let processo = this.props.search.match.params.proccess;
          processo = processo.replace("-","/");
          hist.push('/forms/proccess/');
          this.setState({ processo });
        }
      }

      this.loadEstado(true);
      this.loadFase();
      this.loadSubstancia();
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  setSelected = (selected) => {
    this.setState({ selected });
  }

  updateTable = (selected) => {
    this.setState({ selected });
  }

  newSearch(){
    this.loadRequerimento({}, false);
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  updateField(event) {
    const filter = { ...this.state.filter }
    filter[event.target.name] = event.target.value
    this.setState({ filter });
  }

  updateSubstanciaSelect(event) {
    const filter = { ...this.state.filter }

    let selectedSub = '';
    filter["substancia"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.selectOptionsSub.length; i++){
          if(this.state.selectOptionsSub[i].value === event[j].value){
            selectedSub = event[j];
            
            for(let e = 0; e < this.state.substancias.length; e++){
              if(this.state.substancias[e].id === selectedSub.value){
                filter["substancia"] = this.state.substancias[e];
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ filter, selectedSub });
  }

  updateFaseSelect(event) {
    const filter = { ...this.state.filter }

    let selectedFase = '';
    filter["fase"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.selectOptionsF.length; i++){
          if(this.state.selectOptionsF[i].value === event[j].value){
            selectedFase = event[j];
            
            for(let e = 0; e < this.state.fases.length; e++){
              if(this.state.fases[e].id === selectedFase.value){
                filter["fase"] = this.state.fases[e];
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ filter, selectedFase });
  }

  updateStatesFieldSelect(event) {
    if(event !== null && event.length > 0){
      for(let j = (event.length-1); j < event.length; j++){
        this.setEstado({id: event[j].value}, null, false);
      }
    }else{
      this.setEstado(null, null, false);
    }
  }

  updateCitiesFieldSelect(event) {
    if(event !== null && event.length > 0){
      for(let j = (event.length-1); j < event.length; j++){
        this.setCidade({id: event[j].value}, false);
      }
    }else{
      this.setCidade(null, false);
    }
  }

  render() {
    const { t } = this.props;
    const { processo, name, substancia, fase} = this.state.filter;

    let dados = this.state.data;
    if(processo !== null && processo !== undefined && processo.length > 0){
      dados = dados.filter(obj => obj.processo.toLowerCase().includes(processo.toLowerCase()));
    }
    if(name !== null && name !== undefined && name.length > 0){
      dados = dados.filter(obj => obj.name.toLowerCase().includes(name.toLowerCase()));
    }
    if(substancia !== null && substancia !== undefined && substancia.id !== null && substancia.id !== undefined){
      dados = dados.filter(obj => obj.substancia.id == substancia.id);
    }
    if(fase !== null && fase !== undefined && fase.id !== null && fase.id !== undefined){
      dados = dados.filter(obj => obj.fase.id == fase.id);
    }

    let processosEncontrados = t('forms.processosEncontrados') + ": " + dados.length;

    let view = '';
    if(this.state.hasAccess){
      if(this.state.selected.id !== null && this.state.selected.id !== undefined){
        view =  <CrudEdit 
                  selected = {this.state.selected} 
                  updateTable = {this.updateTable} />
      }else{
        view =  <MatTable 
                  list={dados}
                  setSelected = {this.setSelected}
                  updateTable = {this.updateTable} />
      }
    }

    return (
      <>
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.proccess_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.proccess_form.description')}</h3>
          </Col>
        </Row>
        
        <Row>
          <Col md={12} lg={12}>
            <Card>
              <CardBody>
                <div className="form__form-group" style={{marginBottom: '0px'}}>
                  <h3 className="page-subhead subhead" style={{marginBottom: '0px'}}>{t('forms.filter')}</h3>
                </div>
                <div className="form">

                  <div className="form__half">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('forms.processo')}
                      </span>
                      <div className="form__form-group-field">
                        <input type="text" 
                          name="processo"
                          style={{height: '38px'}}
                          value={this.state.filter.processo}
                          onChange={e => this.updateField(e)}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('forms.titular')}
                      </span>
                      <div className="form__form-group-field">
                        <input type="text" 
                          name="name"
                          style={{height: '38px'}}
                          value={this.state.filter.name}
                          onChange={e => this.updateField(e)}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('forms.substancia')}
                      </span>
                      <div className="form__form-group-field">
                        <Select
                          isMulti = "true"
                          maxMenuHeight="150px"
                          name="substancia"
                          value={this.state.selectedSub}
                          onChange={e => this.updateSubstanciaSelect(e)}
                          options={this.state.selectOptionsSub}
                          clearable={true}
                          className="react-select"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                  </div>

                  

                  <div className="form__half">
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('forms.fase')}
                      </span>
                      <div className="form__form-group-field">
                        <Select
                          isMulti = "true"
                          maxMenuHeight="150px"
                          name="fase"
                          value={this.state.selectedFase}
                          onChange={e => this.updateFaseSelect(e)}
                          options={this.state.selectOptionsF}
                          clearable={true}
                          className="react-select"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('forms.estado')}
                      </span>
                      <div className="form__form-group-field">
                        <Select
                          isMulti = "false"
                          maxMenuHeight="200px"
                          name="states"
                          value={this.state.selectedStates}
                          onChange={e => this.updateStatesFieldSelect(e)}
                          options={this.state.statesList}
                          clearable={true}
                          className="react-select"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        {t('forms.cidade')}
                      </span>
                      <div className="form__form-group-field">
                        <Select
                          isMulti = "false"
                          maxMenuHeight="200px"
                          name="cities"
                          value={this.state.selectedCities}
                          onChange={e => this.updateCitiesFieldSelect(e)}
                          options={this.state.citiesList}
                          clearable={true}
                          className="react-select"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form__form-group">
                    <div className="form__form-group-field">
                      <ButtonToolbar className="form__button-toolbar">
                        <Button className="icon" color="primary" type="submit" 
                          style={{marginBottom: '0px'}}
                          onClick={e => this.newSearch()}>
                          <SearchIcon /> {t('forms.newSearch')}
                        </Button>
                      </ButtonToolbar>
                      <div id="processosEncontradosID" style={{paddingTop: '13px',marginLeft: '10px'}}>
                        {processosEncontrados}
                      </div>
                    </div>
                  </div>


                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          {view}
        </Row>
      </>
    );
  }
}

export default withTranslation('common')(CrudList);